<script lang="ts" setup>
import { Badge } from '@forgd/ui-kit/badge'
import { Button } from '@forgd/ui-kit/button'
import { ArrowLeftIcon } from '@heroicons/vue/24/outline'

const auth = useAuth()

useHead({
  title: 'Market Maker RFQ Demo',
})

const backTo = computed(() =>
  auth.project
    ? `/project/${auth.project.id}/engage-a-market-maker/request-for-quotations`
    : '/engage-a-market-maker/request-for-quotations',
)
</script>

<template>
  <NuxtLayout name="dashboard" container-layout="fluid" :page-header="{ description: 'Free Tools', title: 'Engage with New Market Makers', icon: '/icons/engage-with-new-market-makers.svg' }">
    <template #sidebar>
      <div class="w-0 overflow-hidden" aria-hidden="true" />
    </template>

    <template #header>
      <div class="flex items-center gap-2">
        <Button as-child variant="outline" size="sm">
          <NuxtLink :to="backTo">
            <ArrowLeftIcon aria-hidden="true" />
            Back
          </NuxtLink>
        </Button>
        <img
          src="/icons/engage-with-new-market-makers.svg"
          alt="Market Maker RFQ"
          class="h-8"
        >
        <div class="shrink-0 text-sm font-semibold">
          Market Maker RFQ
        </div>
        <Badge variant="gray" class="px-2 py-0">
          Demo
        </Badge>
      </div>
    </template>

    <template #page-header-prefix>
      <Button as-child variant="outline" size="sm">
        <NuxtLink :to="backTo">
          <ArrowLeftIcon aria-hidden="true" />
          Back
        </NuxtLink>
      </Button>
    </template>

    <template #page-header-suffix>
      <Badge variant="gray" class="px-2 py-0">
        Demo
      </Badge>
    </template>

    <template #app-footer>
      <RfqV2MarketingFooter />
    </template>

    <div class="flex min-h-0 flex-1 flex-col overflow-x-clip">
      <div class="mx-auto w-full max-w-7xl p-10">
        <div class="mb-5 w-full rounded-lg bg-neutral-600/30 p-3 text-xs leading-normal text-secondary">
          <p class="font-semibold">
            This is a demo of a RFQ
          </p>
          <p>
            All market makers represented here are fictional, and this page is meant to show how the flow experience will work. Select quotes, and continue to the next step.
          </p>
        </div>
        <slot />
      </div>
    </div>
  </NuxtLayout>
</template>
